import { Navigate } from "react-router-dom";
import React from "react";
import { useAuth } from "../components/common/Providers/AuthProvider";

const ProtectedAuthRoute = ({ children }: { children: React.ReactNode}) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null; // или спиннер загрузки
  }

  if (isAuthenticated) {
    return <Navigate to="/home/dashboard" replace />;
  }

  return children;
};

export default ProtectedAuthRoute;